import React from 'react'
import Element from 'layouts/Element'

export default class ContentWrap extends Element {
  static get defaultProps () {
    return {}
  }

  get defaultClassNames () {
    return ['content-wrap']
  }

  render () {
    return (
      <div className={this.classNames}>
        {this.props.children}
      </div>
    )
  }
}
